import produce from "immer";
import {
  USERS_CLOSE_ADD_MODAL,
  USERS_CLOSE_EDIT_MODAL,
  USERS_CLOSE_VIEW_MODAL,
  USERS_EDIT_MODAL_OPEN_AND_FETCH,
  USERS_MODAL_SET_USER,
  USERS_OPEN_ADD_MODAL,
  USERS_VIEW_MODAL_OPEN_AND_FETCH,
  GET_USER_PENDING,
  GET_USER_SUCCESS,
  GET_USER_FAILURE,
  USER_SAVE_PENDING,
  USER_SAVE_SUCCESS,
  USER_SAVE_FAILURE,
  DELETE_USER_PENDING,
  DELETE_USER_SUCCESS,
  DELETE_USER_FAILURE,
  USER_EDIT_PENDING,
  USER_EDIT_SUCCESS,
  USER_EDIT_FAILURE,
  UPDATE_USER_PROFILE_PENDING,
  UPDATE_USER_PROFILE_SUCCESS,
  UPDATE_USER_PROFILE_FAILURE,
  //CHANGE_PASSWORD
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_FAILURE,
} from "./constants";

const initialState = {
  isAddModalOpen: false,
  isViewModalOpen: false,
  isEditModalOpen: false,
  isEditing: false,
  isFetching: false,
  currentUser: {},
  alert: {},
  users: [],
  isLoadingUsers: false,
  error: null,
  isUserSaving: false,
  saveError: null,
  message: null,
  isUserDeleting: false,
  deleteError: null,
  doOpen: true,
  updateProfileError: null,
  isUpdatingProfileLoading: false,
  updateUserProfile: null,

  isChangePasswordLoading: false,
  changePasswordError: null,
};
const UserReducer = (state = initialState, action) => {
  return produce(state, (draft) => {
    switch (action.type) {
      case CHANGE_PASSWORD:
        draft.isChangePasswordLoading = true;
        draft.changePasswordError = null;
        break;
      case CHANGE_PASSWORD_SUCCESS:
        draft.isChangePasswordLoading = false;
        draft.changePasswordError = null;
        break;
      case CHANGE_PASSWORD_FAILURE:
        draft.isChangePasswordLoading = false;
        draft.changePasswordError = action.payload.error;
        break;
      case USERS_OPEN_ADD_MODAL:
        draft.isAddModalOpen = true;
        draft.isEditModalOpen = false;
        draft.isEditing = false;
        draft.isViewModalOpen = false;
        draft.currentUser = null;
        draft.isFetching = false;
        break;
      case USERS_CLOSE_ADD_MODAL:
        draft.isAddModalOpen = false;
        break;
      case USERS_VIEW_MODAL_OPEN_AND_FETCH:
        draft.isFetching = true;
        draft.isAddModalOpen = false;
        draft.isEditModalOpen = false;
        draft.currentUser = null;
        draft.isViewModalOpen = true;
        break;
      case USERS_MODAL_SET_USER:
        draft.isFetching = false;
        draft.currentUser = action.payload;
        break;
      case USERS_CLOSE_VIEW_MODAL:
        draft.isViewModalOpen = false;
        break;
      case USERS_EDIT_MODAL_OPEN_AND_FETCH:
        draft.isEditing = true;
        draft.isFetching = true;
        draft.isEditModalOpen = true;
        draft.isAddModalOpen = false;
        draft.isViewModalOpen = false;
        if (draft.currentUser?.id !== action.payload) {
          draft.currentUser = null;
        }
        break;
      case USERS_CLOSE_EDIT_MODAL:
        draft.isEditing = false;
        draft.isEditModalOpen = false;
        break;
      case GET_USER_PENDING:
        draft.isLoadingUsers = action.payload.isLoadingUsers;
        draft.saveError = null;
        draft.isEditModalOpen = false;
        draft.isAddModalOpen = false;
        draft.isViewModalOpen = false;
        draft.doOpen = true;
        break;
      case GET_USER_SUCCESS:
        draft.isLoadingUsers = false;
        draft.users = action.payload;
        draft.isFetching = false;
        break;
      case GET_USER_FAILURE:
        draft.isLoadingUsers = false;
        draft.error = action.payload.error;
        draft.isFetching = false;
        break;
      case USER_SAVE_PENDING:
        draft.isUserSaving = action.payload.isUserSaving;
        draft.saveError = null;
        break;
      case USER_SAVE_SUCCESS:
        draft.isUserSaving = false;
        draft.message = action.payload.message;
        draft.isAddModalOpen = false;
        draft.saveError = null;
        break;
      case USER_SAVE_FAILURE:
        draft.isUserSaving = false;
        draft.saveError = action.payload.error;
        break;

      //EDIT USERS

      case USER_EDIT_PENDING:
        draft.isUserSaving = action.payload.isUserSaving;
        draft.saveError = null;
        break;
      case USER_EDIT_SUCCESS:
        draft.isUserSaving = false;
        draft.message = action.payload.message;
        draft.isAddModalOpen = false;
        draft.saveError = null;
        break;
      case USER_EDIT_FAILURE:
        draft.isUserSaving = false;
        draft.saveError = action.payload.error;
        break;

      //DELETE USER
      case DELETE_USER_PENDING:
        draft.isUserDeleting = action.payload.isUserDeleting;
        draft.deleteError = null;
        draft.doOpen = true;
        break;
      case DELETE_USER_SUCCESS:
        draft.isUserDeleting = false;
        draft.message = action.payload.message;
        draft.deleteError = null;
        draft.doOpen = false;
        break;
      case DELETE_USER_FAILURE:
        draft.isUserDeleting = false;
        draft.deleteError = action.payload.error;
        draft.doOpen = false;
        break;
      // for update user profile
      case UPDATE_USER_PROFILE_PENDING:
        draft.isUpdatingProfileLoading = true;
        draft.updateUserProfile = null;
        draft.updateProfileError = null;
        break;
      case UPDATE_USER_PROFILE_SUCCESS:
        draft.isUpdatingProfileLoading = false;
        draft.updateUserProfile = action.payload.data;
        draft.updateProfileError = null;
        break;
      case UPDATE_USER_PROFILE_FAILURE:
        draft.updateProfileError = action.payload.error;
        draft.updateUserProfile = null;
        draft.isUpdatingProfileLoading = false;
        break;
      default:
        return state;
    }
  });
};
export default UserReducer;
